import { render, staticRenderFns } from "./dentalBillingTest.vue?vue&type=template&id=b2817fa0&scoped=true&"
import script from "./dentalBillingTest.vue?vue&type=script&lang=js&"
export * from "./dentalBillingTest.vue?vue&type=script&lang=js&"
import style0 from "./dentalBillingTest.vue?vue&type=style&index=0&id=b2817fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2817fa0",
  null
  
)

export default component.exports